import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";

const DEFAULTS = { delivery_delay: "24/48h", return_days: 30, free_shipping_threshold: 79, shipping_cost: 5.9 };
const SettingsContext = createContext(DEFAULTS);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings({ ...DEFAULTS, ...data })).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
